import { RiCaravanLine, RiCaravanFill } from '@remixicon/react'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'
import {
  Perm_CarCompany_View,
  Perm_Drive_View,
  Perm_GenusHistory_View,
  Perm_Standard_View
} from '../../app/hooks/premissionScreen'

const icons = {
  RiCaravanLine,
  RiCaravanFill
}

export const companyMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'company',
    title: 'Xe công ty/Lái xe',
    icon: icons.RiCaravanLine,
    iconActive: icons.RiCaravanFill,
    premissions: Perm_CarCompany_View,
    children: [
      createItem({
        id: 'company-car',
        title: 'Xe công ty',
        url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.CAR}`,
        premissions: Perm_CarCompany_View
      }),
      createItem({
        id: 'driver-car',
        title: 'Lái xe',
        url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.DRIVER}`,
        premissions: Perm_Drive_View
      }),
      createCollapseGroup({
        id: 'company-genus-history',
        title: 'Lịch sử chi',
        premissions: Perm_GenusHistory_View,
        children: [
          createItem({
            id: 'company-genus-history-oli',
            title: 'Dầu không khoán',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.COST_OLI}`,
            premissions: Perm_GenusHistory_View
          }),
          createItem({
            id: 'company-edit-repair',
            title: 'Sửa chữa',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.COST_REPAIR}`,
            premissions: Perm_GenusHistory_View
          }),
          createItem({
            id: 'company-cost-general',
            title: 'Quản lý chung',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.COST_GENERAL}`,
            premissions: Perm_GenusHistory_View
          }),
          createItem({
            id: 'company-cost-road',
            title: 'Tiền đường',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.COST_ROAD}`,
            premissions: Perm_GenusHistory_View
          }),
          createItem({
            id: 'company-cost-bonus',
            title: 'Thưởng',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.COST_BONUS}`,
            premissions: Perm_GenusHistory_View
          })
        ]
      }),
      createCollapseGroup({
        id: 'company-norms',
        title: 'Định mức thanh toán',
        premissions: Perm_Standard_View,
        children: [
          createItem({
            id: 'company-norms-salary-month',
            title: 'Lương tháng',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.NORMS_SALARY_MONTH}`,
            premissions: Perm_Standard_View
          }),
          createItem({
            id: 'company-norms-salary-order',
            title: 'Lương chuyến',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.NORMS_SALARY_ORDERS}`,
            premissions: Perm_Standard_View
          }),
          createItem({
            id: 'company-norms-degradation',
            title: 'Định mức tiêu hao xe',
            url: `/${ROUTES.COMPANY}/${ROUTES.COMPANY_CHILD.NORMS_DEGRADATION}`,
            premissions: Perm_Standard_View
          })
        ]
      })
    ]
  })
]
